import React, { useState, useEffect } from "react";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import MenuIcon from '@mui/icons-material/Menu';
import {AppBar, Tab, Tabs, Drawer, List, ListItem, ListItemText, IconButton, Toolbar} from '@mui/material';
import {Route, Routes, Link, useLocation, useNavigate} from 'react-router-dom';
import './Dashboard.scss';
import { TokenService } from '../../services/token.service';
import { actionLoadUserConfig } from '../../redux/action/layerConfig';
import { useDispatch } from 'react-redux';
import Home from './home/Home';
import Map from './map/Map';
import Status from './status/Status';
import StatusAdmin from './status/StatusAdmin';
import Event from './event/Event';
import User from './user/User';
import Help from './help/Help';
import LogsPage from "./logs/Logs";
import { activityStatusAction, activityStatusForUpdate } from "../../redux/action/activity";

export default function Dashboard() {
    const [drawerOpen, setDrawerOpen] = useState(false);
    let urlHash: string = "";
    let id = localStorage.getItem("activity_id")?.toString() || "";
    const url = useLocation();
    const dispatch = useDispatch();
    const mainInfo = TokenService.mainInfo();
    const isAdmin = mainInfo.usertype === 'admin';
    useEffect(() => {
        dispatch(actionLoadUserConfig() as any)
    }, [dispatch])
    
    useEffect(() => {
        if (url.hash !== urlHash) {
            dispatch(activityStatusForUpdate(url.hash, id) as any);
        }
        activityStatus(url.hash);
    }, [url.hash]);
    const location = useLocation();
    const navigate = useNavigate();
    const pathArray = ['/', '/#map', '/#status', '/#statusadmin', '/#event', '/#user', '/#help'];
    const token = TokenService.getToken();

    function onLogout() {
        dispatch(activityStatusForUpdate("logout", localStorage.getItem("activity_id")) as any);
        dispatch(activityStatusForUpdate("LoggedOut", token) as any);
        dispatch(activityStatusAction("LoggedOut") as any);
        TokenService.setToken(null);
        localStorage.removeItem("activity_id");
        navigate('/login');
    }
    async function activityStatus(path: string) {
        urlHash = path;
        dispatch(activityStatusAction(path) as any);
    };

    function getBaseRouteName() {
        const hashPath = location.pathname + location.hash;
        for (let i = pathArray.length - 1; i >= 0; i--) {
            const path = pathArray[i];
            const isMatch = location.pathname.startsWith(path);
            if (isMatch) {
                location.pathname = hashPath;
                return hashPath;
            }
        }
        return '/';
    }
    const toggleDrawer = (open : boolean) => (event : any) => {
        if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
            return;
        }
        setDrawerOpen(open);
    };

    const drawer = (
        <div role="presentation" onClick={toggleDrawer(false)} onKeyDown={toggleDrawer(false)} >
            <List>
                <ListItem button component={Link} to="/">
                    <ListItemText primary="Home" />
                </ListItem>
                <ListItem button component={Link} to="/#map">
                    <ListItemText primary="Map" />
                </ListItem>
                {!isAdmin &&
		<ListItem button component={Link} to="/#status">
                    <ListItemText primary="Status" />
                </ListItem>
                }
                {isAdmin &&
		<ListItem button component={Link} to="/#statusadmin">
                    <ListItemText primary="Status" />
                </ListItem>
                }
                <ListItem button component={Link} to="/#event">
                    <ListItemText primary="Event" />
                </ListItem>
                {isAdmin &&
                <ListItem button component={Link} to="/#user">
                    <ListItemText primary="User" />
                </ListItem>
		}
		{isAdmin &&
		<ListItem button component={Link} to="/#logs">
                    <ListItemText primary="Logs" />
                </ListItem>
                }
                <ListItem button component={Link} to="/#help">
                    <ListItemText primary="Help" />
                </ListItem>
                <ListItem button onClick={onLogout}>
                    <ExitToAppIcon />
                    <ListItemText primary="Logout" />
                </ListItem>
            </List>
        </div>
    );
    
    return (
        <div className='Dashboard'>
            <div>
                <AppBar position='relative' color='default'>
                    <Toolbar className='navbar'>
                        <div className='logo'>
                            <img src='assets/images/griffin.gif' alt='Griffin Logo' />
                        </div>
                        <IconButton edge="end" color="inherit" aria-label="menu" onClick={toggleDrawer(true)} className="menuButton" >
                            <MenuIcon />
                        </IconButton>
                        <Tabs value={getBaseRouteName()} indicatorColor='primary' textColor='primary' variant='scrollable' aria-label='full width tabs example' className='tabs'>
                            <Tab component={Link} to='/' value='/' label='Home' />
                            <Tab component={Link} to='/#map' value='/#map' label='Map' />
                            {!isAdmin &&
                            <Tab component={Link} to='/#status' value='/#status' label='Status' />
                            }
                            {isAdmin &&
                            <Tab component={Link} to='/#statusadmin' value='/#statusadmin' label='Status' />
                            }
                            <Tab component={Link} to='/#event' value='/#event' label='Event' />
                            {isAdmin &&
                            <Tab component={Link} to='/#user' value='/#user' label='User' />
                            }
			    {isAdmin && (
                            <Tab component={Link} to="/#logs" value="/#logs" label="Logs" />
                            )}
                            <Tab component={Link} to='/#help' value='/#help' label='Help' />
                            <Tab icon={<ExitToAppIcon />} onClick={onLogout} />
                        </Tabs>
                    </Toolbar>
                </AppBar>
                <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
                    {drawer}
                </Drawer>
            </div>
            <div id='app' className='body'>
                <Routes>
                    <Route path='/' element={<Home />} />
                    <Route path='/#map' element={<Map />} />
                    {!isAdmin && <Route path='/#status' element={<Status />} />}
                    {isAdmin && <Route path='/#statusadmin' element={<StatusAdmin />} />}
                    <Route path='/#event' element={<Event />} />
                    <Route path='/#user/*' element={<User />} />
                    <Route path='/#help' element={<Help />} />
                    {isAdmin && <Route path="/#logs" element={<LogsPage />} />}
                </Routes>
            </div>
        </div>
    );
}
